/**
 * ชื่อผลิตภัณฑ์ของรายการเช่า สำหรับแสดงใต้ชื่อบริษัท/โครงการในตารางรายการเช่า
 *
 * feedback amintra (4 ก.ย. 2026): "รายการเช่า ในตารางต่อจากแถวบริษัท/โครงการ
 * ควรจะเพิ่มแถวชื่อผลิตภัณฑ์" — เดิมต้องเปิดรายละเอียดทีละรายการถึงจะรู้ว่าเช่าสินค้าอะไร
 *
 * ข้อมูลมากับ API รายการอยู่แล้ว (`rental_items[].product_name` + `product_name` ระดับบนสุด)
 * จึงไม่ต้องยิงเพิ่มและไม่มี N+1
 *
 * สัญญาหนึ่งมีได้หลายสินค้า (prod ตอนนี้ 798/798 มีชนิดเดียว แต่ระบบรองรับหลายชนิด
 * และ dev มีข้อมูลแบบนั้นจริง) → รวมชื่อซ้ำแล้วตัดท้ายเมื่อยาวเกิน เพื่อไม่ให้ดันความสูงแถว
 */

const MAX_SHOWN = 2;

export interface RentalProductSource {
  product_name?: string | null;
  rental_items?: Array<{
    product_name?: string | null;
    product?: { name?: string | null } | null;
  } | null> | null;
}

export interface RentalProductLabel {
  /** ข้อความที่แสดงในตาราง (ตัดท้ายแล้ว) */
  text: string;
  /** รายชื่อเต็มสำหรับ title/tooltip — เท่ากับ text เมื่อไม่ได้ตัด */
  title: string;
  /** จำนวนสินค้าที่ไม่ซ้ำกันทั้งหมด */
  count: number;
}

/** ชื่อสินค้าที่ไม่ซ้ำ เรียงตามลำดับที่พบในรายการ */
export function getRentalProductNames(rental?: RentalProductSource | null): string[] {
  const names: string[] = [];
  const push = (raw?: string | null) => {
    const name = (raw || '').trim();
    if (name && !names.includes(name)) names.push(name);
  };

  for (const item of rental?.rental_items || []) {
    push(item?.product_name || item?.product?.name);
  }
  // สัญญาที่ API ไม่ได้ส่ง rental_items มาด้วย (บาง endpoint ส่งเฉพาะสรุป)
  if (names.length === 0) push(rental?.product_name);

  return names;
}

export function getRentalProductLabel(rental?: RentalProductSource | null): RentalProductLabel | null {
  const names = getRentalProductNames(rental);
  if (names.length === 0) return null;

  const title = names.join(' · ');
  const text =
    names.length <= MAX_SHOWN
      ? title
      : `${names.slice(0, MAX_SHOWN).join(' · ')} +${names.length - MAX_SHOWN}`;

  return { text, title, count: names.length };
}
